import React, { useState } from 'react'

export default ({title, subtitle, theme}) => {

  let _theme = {
    borderColor: 'border-grey-400',
    subtitleColor: 'text-black',
    titleColor: 'text-sky-500'
  }

  if (theme === 'dark') {
    _theme = {
      borderColor: 'border-sky-600',
      subtitleColor: 'text-gray-400',
      titleColor: 'text-white'
    }
  }

  if (theme === 'blue') {
    _theme = {
      borderColor: 'border-sky-300',
      subtitleColor: 'text-white',
      titleColor: 'text-white'
    }
  }

  if (theme === 'black') {
    _theme = {
      borderColor: 'border-sky-300',
      subtitleColor: 'text-gray-500',
      titleColor: 'text-gray-700'
    }
  }

  return (
    <div className={`border-b ${_theme.borderColor} mb-8`}>
      {
        subtitle &&
        <h2 className={`text-xs tracking-[6px] uppercase ${_theme.subtitleColor}`}>{subtitle}</h2>
      }
      <h1 className={`text-4xl md:text-5xl lg:text-6xl ${_theme.titleColor} font-bold mb-4`}>{title} </h1>
    </div>
  )
}